<template>
<div v-if="submenuItems.length > 0" class="bg-gray-500 mt-1">
    <div class="flex flex-col-reverse py-1 items-center container-1024 mx-auto">
        <nav class="lg:w-11/12 mt-2 mb-1  justify-center">
            <ul class="flex text-white text-xs lg:text-base">
                <li class="flex-auto px-2 md:text-center" v-for="(item, index) in submenuItems" :key=index>
                    <span>
                        <router-link
                            v-if="item.post"
                            :to="routeFor('pagedetail', {path: path, slug: item.post.title, pk: item.post.id})"
                        >
                            {{ item.name }}
                        </router-link>
                        <a v-else :href="item.url">{{item.name}}</a>
                    </span>
                </li>
            </ul>
        </nav>
    </div>
  </div>
</template>
<script>
import { reactive } from 'vue'
import { useRoute } from 'vue-router'
import api from '@/services'
import { routeFor } from '@/helpers'

export default {
    setup() {
        const route = useRoute()

        async function handleLogout()
        {
            const response = await api.auth.logout()
            window.location = response.request.responseURL
        }

        const userData = JSON.parse(sessionStorage.getItem('user-data'))
        const compoundName = `${userData.first_name} ${userData.last_name}`

        const state = reactive({
            submenuItems: [],
            path: route.params.path || route.params.slug,
            routeFor: routeFor,
            personName: (compoundName.trim()) ? compoundName : userData.username,
            handleLogout
        })

        api.menu.subMenuPages(route.params.path || route.params.slug).then(result => {
            state.submenuItems = result
        })

        return state
    }
}
</script>
<style>
</style>